import React from "react";
import { AppContext } from "../context";
import { QuestionSelects } from "../type";
import QuestionSelectBMI from "./QuestionSelectBMI";
import QuestionSelectMultiSelect from "./QuestionSelectMultiSelect";
import QuestionSelectSelect from "./QuestionSelectSelect";
import QuestionSelectTextQ1 from "./QuestionSelectTextQ1";

const QuestionSelects: React.VFC<QuestionSelects> = (props) => {
    const required = props.currentQuestion.required;

    const renderSwitch = ({ state, dispatch }) => {
        switch (props.currentQuestion.question_type) {
            case "TEXT":
                if (state.currentQuestionNo == 1)
                    return (
                        <QuestionSelectTextQ1
                            questionSelects={props.questionSelects}
                            currentQuestionNo={state.currentQuestionNo}
                            dispatch={dispatch}
                            lastAnswers={props.lastAnswers}
                        />
                    );
            case "SELECT":
                return (
                    <QuestionSelectSelect
                        questionSelects={props.questionSelects}
                        currentQuestionNo={state.currentQuestionNo}
                        dispatch={dispatch}
                    />
                );
            case "MULTI_SELECT":
                return (
                    <QuestionSelectMultiSelect
                        default_next_question_no={
                            props.currentQuestion.default_next_question_no
                        }
                        questionSelects={props.questionSelects}
                        currentQuestionNo={state.currentQuestionNo}
                        dispatch={dispatch}
                        required={required}
                        lastAnswers={props.lastAnswers}
                        isBackState={state.isBackState}
                    />
                );
            case "BMI":
                return (
                    <QuestionSelectBMI
                        questionSelects={props.questionSelects}
                        currentQuestionNo={state.currentQuestionNo}
                        dispatch={dispatch}
                        lastAnswers={props.lastAnswers}
                    />
                );
            default:
                throw new Error("Undefined Switch Component");
        }
    };

    return (
        <AppContext.Consumer>
            {({ state, dispatch }) => <>{renderSwitch({ state, dispatch })}</>}
        </AppContext.Consumer>
    );
};

export default QuestionSelects;
